import { useRecentSearches } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import {
  SearchSortItem,
  SearchStickySortMenuSelect,
} from '../../../components/SearchStickySortMenuSelect/SearchStickySortMenuSelect';
import { createSearchUrl } from '../../../helpers/createSearchUrl';
import { getSortOptionFromUrl } from '../../../helpers/queryStringHelpers/getSortOptionFromUrl';
import { getPropertyStatusFromUrl } from '../../../helpers/queryStringHelpers/queryStringHelpers';
import { useAccountContext } from '../../../app-kit/contexts/AccountContext/AccountContext';
import { useSearchLandingPageBySlugQuery } from '../../graphql/useSearchLandingPageBySlugQuery';
import { getSortOptionsByPropertyStatus } from '../../../helpers/getSortOptionsByPropertyStatus';

export const SearchLandingSortMenuSelectWithData: FunctionComponent = () => {
  const { isSignedIn } = useAccountContext();
  const { saveRecentLocationSearch } = useRecentSearches({ isSignedIn });
  const cachedQuery = useSearchLandingPageBySlugQuery();

  const searchQuery = cachedQuery?.searchQuery || '';
  const sortOptions = cachedQuery?.header?.sortOptions;
  if (!sortOptions) return null;

  const propertyStatus = getPropertyStatusFromUrl(searchQuery);
  const sortOption = getSortOptionFromUrl(searchQuery);

  const options = getSortOptionsByPropertyStatus(sortOptions, propertyStatus);
  const selectedItem = options?.find((option) => option.value === sortOption);
  if (!selectedItem) return null;

  const setSelectedItem = (item: SearchSortItem) => {
    createSearchUrl({
      currentUrl: searchQuery,
      updates: { sortOption: item.value, pageNumber: '' },
      historyPushFn: (url) => window.location.assign(url),
      saveRecentLocationSearch,
    });
  };

  return (
    <SearchStickySortMenuSelect
      id="search-sort-menu-select"
      options={options}
      selectedItem={selectedItem}
      setSelectedItem={setSelectedItem}
    />
  );
};
